import searchList from '@/pages/report/searchList';
import evaluationList from '@/pages/report/evaluationList';

const reportRouter = [
  {
    path: '/report/searchList', name: 'reportSearchList', component: searchList, meta: { c: 'report', a: 'searchList' }
  },
  {
    path: '/report/evaluationList/:teacherid', name: 'evaluationList', component: evaluationList, meta: { c: 'report', a: 'evaluationList' }
  },
];

export default reportRouter;

